import { css } from '@emotion/css';

const card = css({
  '&.MuiCard-root': {
    maxWidth: '480px',
    margin: '0 auto',
    overflow: 'hidden',
  },
});

const cardContent = css({
  '&.MuiCardContent-root': {
    padding: '24px',
  },
});

const headerStack = css({
  '&.MuiStack-root': {
    marginBottom: '24px',
  },
});

const avatarContainer = css({
  '&.MuiBox-root': {
    flex: 1,
  },
});

const detailRow = css({
  '&.MuiBox-root': {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
    paddingTop: '8px',
    paddingBottom: '8px',
    alignItems: 'start',
  },
});

const detailValue = css({
  '&.MuiTypography-root': {
    wordBreak: 'break-word',
  },
});

const BeneficiaryCardStyles = {
  card,
  cardContent,
  headerStack,
  avatarContainer,
  detailRow,
  detailValue,
};

export default BeneficiaryCardStyles;
